import {Component, Input, OnInit} from '@angular/core';
import StyleFormatter from '../../../utils/style-formatter';

@Component({
  selector: 'file-repository-summary',
  templateUrl: './file-repository-summary.component.html',
  styleUrls: ['./file-repository-summary.component.scss']
})
export class FileRepositorySummaryComponent implements OnInit {

  styleFormatter;

  @Input() selection: any;
  @Input() normalizationGroups: any;

  constructor() {
    this.styleFormatter = StyleFormatter;
  }

  ngOnInit(): void {
  }

  getNormalizationGroupName(id): string {
    const group = this.normalizationGroups.find((groupItem) => {
      return groupItem.id === id;
    });
    if (group) {
      return group.groupName;
    }
  }

}
